<template lang="pug">
b-row
    b-col.my-3.my-lg-5.px-0.px-md-3(lg="11", offset-lg="1")
        Card(
            :backLink="[`${company.title}`, `/company/${companyId}/`]",
            :title="offer.title",
            :contactButton="offer.contact ? `mailto:${offer.contact}` : false",
            :image="company.image",
            :subtitle="company.title",
            :subtitle2="offer.location",
            :text="offer.description",
            profile,
            :closed="offer.closed"
        )
</template>

<script>
import Card from "@/components/CardComponent.vue";

export default {
    name: "OfferDetailPage",
    components: { Card },
    computed: {
        companyId() {
            return this.$router.history.current.params.companyId;
        },
        company() {
            return this.$store.getters.companyById(this.companyId);
        },
        offer() {
            return this.company.offers.find((offer) => offer.id === this.$router.history.current.params.offerId);
        },
    },
};
</script>
